import { useEffect, useRef } from 'react';
import { bridge, isNotNil } from 'shared/src/utils';

export const useLogViewLaboratory = (params: Record<string, boolean | undefined>) => {
  const hasLoggedRef = useRef(false);

  useEffect(() => {
    if (hasLoggedRef.current) return;

    const ready = Object.values(params).every(isNotNil);
    if (!ready) return;

    const formattedParams = Object.fromEntries(
      Object.entries(params).map(([key, value]) => [key, value ? '1' : '0'])
    );

    bridge.logAnalyticsEvent({
      channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
      name: 'VIEW',
      analytics: {
        SCREEN: 'LABORATORY',
        ...formattedParams,
      },
    });

    hasLoggedRef.current = true;
  }, [params]);
};